import React, { useState, useEffect } from 'react';

import { Input } from 'antd';


const InputDinheiro = ({initialValue, onChangeValue, readonly=false, ...props}) => {

    
    
    
    const [valor, setValor] = useState(initialValue || 0);
    const [valorFormatado, setValorFormatado] = useState(0);

    
    
    useEffect(() => {
        formataValor();
    }, [valor]);
    
    let casasDecimais = (initialValue + "").split(".");
    casasDecimais = casasDecimais[1] && casasDecimais[1].length >=2 ? casasDecimais[1].length : 2;

    const formataValor = () =>{
        if(isNaN(valor)){
            setValorFormatado("R$ 0,00");
            return;
        }
        const v = valor.toFixed(casasDecimais);
        const valorFormatado = "R$ " + v.replace(".",",");
        setValorFormatado(valorFormatado);
    }

    const onValueChange = (data, a) => {
        console.log(data);
        console.log(a)
        const novoValor = data.target.value.replace("R$ ", "");
        if(isNaN(parseFloat(novoValor))){
            setValor(0);
            return;
        }

        const novoValorCents = novoValor.replace(".", "").replace(",", "");
        
        const novoValorDecimal = (parseInt(novoValorCents) / Math.pow(10, casasDecimais));
        dispatchOnChange(novoValorDecimal);
        setValor(novoValorDecimal);
    }

    const dispatchOnChange = (novoValor) => {
        if(onChangeValue){
            onChangeValue(novoValor)
        }
    }

  
    return ( 
    <Input.Group compact={true}>
        <Input
            disabled={readonly}
            
            value={valorFormatado}
            type="text"
            onChange={onValueChange}
            onFocus={evt => evt.target.selectionStart = evt.target.selectionEnd = evt.target.value.length}
            onClick={evt => evt.target.selectionStart = evt.target.selectionEnd = evt.target.value.length}
            
            style={{textAlign: 'right'}}
            inputMode="numeric"
            
            ></Input>
        
    </Input.Group>);
    // return (<Dinheiro
    //     value={valor}
    //     displayType="input" 
    //     customInput={Input} 
    //     type="text"
    //     onChange={onValueChange}
    //     {...props}
    // ></Dinheiro>)
}

export {InputDinheiro}
